import _slicedToArray from "/opt/build/repo/packages/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/packages/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/packages/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/packages/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/packages/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/packages/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { hashQueryKeyByOptions, parseFilterArgs, matchQuery } from './utils.mjs';
import { Query } from './query.mjs';
import { notifyManager } from './notifyManager.mjs';
import { Subscribable } from './subscribable.mjs'; // CLASS

var QueryCache = /*#__PURE__*/function (_Subscribable) {
  _inherits(QueryCache, _Subscribable);

  var _super = _createSuper(QueryCache);

  function QueryCache(config) {
    var _this;

    _classCallCheck(this, QueryCache);

    _this = _super.call(this);
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  _createClass(QueryCache, [{
    key: "build",
    value: function build(client, options, state) {
      var _options$queryHash;

      var queryKey = options.queryKey;
      var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : hashQueryKeyByOptions(queryKey, options);
      var query = this.get(queryHash);

      if (!query) {
        query = new Query({
          cache: this,
          logger: client.getLogger(),
          queryKey: queryKey,
          queryHash: queryHash,
          options: client.defaultQueryOptions(options),
          state: state,
          defaultOptions: client.getQueryDefaults(queryKey)
        });
        this.add(query);
      }

      return query;
    }
  }, {
    key: "add",
    value: function add(query) {
      if (!this.queriesMap[query.queryHash]) {
        this.queriesMap[query.queryHash] = query;
        this.queries.push(query);
        this.notify({
          type: 'added',
          query: query
        });
      }
    }
  }, {
    key: "remove",
    value: function remove(query) {
      var queryInMap = this.queriesMap[query.queryHash];

      if (queryInMap) {
        query.destroy();
        this.queries = this.queries.filter(function (x) {
          return x !== query;
        });

        if (queryInMap === query) {
          delete this.queriesMap[query.queryHash];
        }

        this.notify({
          type: 'removed',
          query: query
        });
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;

      notifyManager.batch(function () {
        _this2.queries.forEach(function (query) {
          _this2.remove(query);
        });
      });
    }
  }, {
    key: "get",
    value: function get(queryHash) {
      return this.queriesMap[queryHash];
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.queries;
    }
  }, {
    key: "find",
    value: function find(arg1, arg2) {
      var _parseFilterArgs = parseFilterArgs(arg1, arg2),
          _parseFilterArgs2 = _slicedToArray(_parseFilterArgs, 1),
          filters = _parseFilterArgs2[0];

      if (typeof filters.exact === 'undefined') {
        filters.exact = true;
      }

      return this.queries.find(function (query) {
        return matchQuery(filters, query);
      });
    }
  }, {
    key: "findAll",
    value: function findAll(arg1, arg2) {
      var _parseFilterArgs3 = parseFilterArgs(arg1, arg2),
          _parseFilterArgs4 = _slicedToArray(_parseFilterArgs3, 1),
          filters = _parseFilterArgs4[0];

      return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
        return matchQuery(filters, query);
      }) : this.queries;
    }
  }, {
    key: "notify",
    value: function notify(event) {
      var _this3 = this;

      notifyManager.batch(function () {
        _this3.listeners.forEach(function (_ref) {
          var listener = _ref.listener;
          listener(event);
        });
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var _this4 = this;

      notifyManager.batch(function () {
        _this4.queries.forEach(function (query) {
          query.onFocus();
        });
      });
    }
  }, {
    key: "onOnline",
    value: function onOnline() {
      var _this5 = this;

      notifyManager.batch(function () {
        _this5.queries.forEach(function (query) {
          query.onOnline();
        });
      });
    }
  }]);

  return QueryCache;
}(Subscribable);

export { QueryCache };